import { useMutation, MutationConfig } from "react-query";
import { IError } from "api/types";
import {
	saveRiskProfileAnswers,
	saveSenderBankAccount,
	submitWireTransferProof,
	submitWireTransferTopUp,
} from "./request";
import {
	ISaveRiskProfileAnswersPayload,
	ISaveRiskProfileAnswersResponse,
	ISaveSenderBankAccountPayload,
	ISaveSenderBankAccountResponse,
	ISubmitWireTransferProofPayload,
	ISubmitWireTransferProofResponse,
	ISubmitWireTransferTopUpPayload,
	ISubmitWireTransferTopUpResponse,
} from "./types";

export const useSaveRiskProfileAnswersMutation = (
	options?: MutationConfig<
		ISaveRiskProfileAnswersResponse,
		IError,
		ISaveRiskProfileAnswersPayload
	>,
) => {
	return useMutation<ISaveRiskProfileAnswersResponse, IError, ISaveRiskProfileAnswersPayload>(
		saveRiskProfileAnswers,
		options,
	);
};

const saveSenderBankAccountLogged = async (payload: ISaveSenderBankAccountPayload) => {
	const response = await saveSenderBankAccount(payload);

	return response;
};

export const useSaveSenderBankAccountMutation = (
	options?: MutationConfig<
		ISaveSenderBankAccountResponse,
		IError,
		ISaveSenderBankAccountPayload
	>,
) => {
	return useMutation<ISaveSenderBankAccountResponse, IError, ISaveSenderBankAccountPayload>(
		saveSenderBankAccountLogged,
		options,
	);
};

const submitWireTransferTopUpLogged = async (payload: ISubmitWireTransferTopUpPayload) => {
	const response = await submitWireTransferTopUp(payload);

	return response;

};

export const useSubmitWireTransferTopUpMutation = (
	options?: MutationConfig<
		ISubmitWireTransferTopUpResponse,
		IError,
		ISubmitWireTransferTopUpPayload
	>,
) => {
	return useMutation<
		ISubmitWireTransferTopUpResponse,
		IError,
		ISubmitWireTransferTopUpPayload
	>(submitWireTransferTopUpLogged, options);
};

const submitWireTransferProofLogged = async (payload: ISubmitWireTransferProofPayload) => {
	const response = await submitWireTransferProof(payload);

	return response;
};

export const useSubmitWireTransferProofMutation = (
	options?: MutationConfig<
		ISubmitWireTransferProofResponse,
		IError,
		ISubmitWireTransferProofPayload
	>,
) => {
	return useMutation<
		ISubmitWireTransferProofResponse,
		IError,
		ISubmitWireTransferProofPayload
	>(submitWireTransferProofLogged, options);
};
